<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <!-- 结果展示 -->
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>供应商付款列表</h1>
                                </div>
                                <div class="h-pieceCon2" style="padding:0">
                                    <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                                        <el-table
                                            ref="ddtable"
                                            :data="tableData"
                                            @selection-change="handleSelectionChange"
                                            stripe
                                            border
                                            :show-overflow-tooltip="true"
                                            style="width: 100%"
                                            max-height="450"
                                        >
                                            <el-table-column
                                                type="selection"
                                                fixed
                                                width="40">
                                            </el-table-column>
                                            <el-table-column
                                                fixed
                                                prop="supplierName"
                                                label="供应商"
                                                :show-overflow-tooltip="true"
                                                width="200">
                                            </el-table-column>
                                            <el-table-column
                                                fixed
                                                prop="purchaseOrgCode"
                                                label="采购公司"
                                                :show-overflow-tooltip="true"
                                                width="220"
                                            >
                                                <template slot-scope="scope">
                                                    <dictname category="supplier_cpy_code"
                                                               :v="scope.row.purchaseOrgCode"/>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                fixed
                                                prop="payNo"
                                                label="报账单号"
                                                :show-overflow-tooltip="true"
                                                width="150">
                                            </el-table-column>
                                            <el-table-column
                                                prop="fkDate"
                                                label="付款提交时间"
                                                :show-overflow-tooltip="true"
                                                width="150">
                                            </el-table-column>
                                            <el-table-column
                                                prop="fkStatus"
                                                label="付款状态"
                                                :show-overflow-tooltip="true"
                                                width="100">
                                                <template slot-scope="scope">
                                                    <dictname category="fukuan_status"  :v="scope.row.fkStatus"/>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="paymentSystem"
                                                label="付款系统"
                                                :show-overflow-tooltip="true"
                                                width="100">
                                            </el-table-column>
                                            <el-table-column
                                                prop="paymentPrice"
                                                label="付款金额"
                                                :show-overflow-tooltip="true"
                                                width="100">
                                            </el-table-column>
                                            <el-table-column
                                                prop="deductPrice"
                                                label="扣款金额"
                                                :show-overflow-tooltip="true"
                                                width="100">
                                            </el-table-column>
                                            <el-table-column
                                                prop="finalPrice"
                                                label="最终金额"
                                                :show-overflow-tooltip="true"
                                                width="100">
                                            </el-table-column>
                                            <el-table-column
                                                fixed="right"
                                                label="操作"
                                            >
                                                <template slot-scope="scope">
                                                    <div style="text-align: left;">
                                                        <el-button
                                                            size="small" class="h-tableLink h-btn"
                                                            @click="getFukuanData(scope.row.id)">查看
                                                        </el-button>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                    <div class="bannerBox2">
                                        <div class="h-row h-mrt1">
                                            <div class="h-rowIn">
                                                <div class="h-rowBox">
                                                    <div class="h-rowCon">
                                                        <div class="h-pieceIn2">
                                                            <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                                            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                                                <h1>审核信息</h1>
                                                            </div>
                                                            <div class="h-pieceCon2 ">
                                                                <div class="h-formLine weekplandetail11"
                                                                     style="position: relative;">
                                                                    <el-form :inline="true" :model="delData">
                                                                        <el-form-item label="审批意见"
                                                                                      class="h-elformWrap-2 newBox"
                                                                                      required
                                                                                      style="width: 100%!important;">
                                                                            <el-input
                                                                                v-model="delData.reviewComments"
                                                                                placeholder="请输入"></el-input>
                                                                        </el-form-item>
                                                                    </el-form>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="text-align: center;margin-top: 0.3rem">
                                        <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack"> 返回</el-button>
                                        <el-button class="h-btn h-bBtn h-bgred" @click="pass(2)">驳回</el-button>
                                        <el-button class="h-btn h-bBtn h-bggreen" @click="pass(1)">通过</el-button>
                                        <el-button class="h-btn h-bBtn" @click="viewPress">审批跟踪</el-button>
                                    </div>
                                    <viewhistory :visible.sync="showHistory" v-if="showHistory" :id="instid"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <createApply :visible.sync="showNewFukuan" v-if="showNewFukuan" :fukuanId="this.fukuanId" title="付款详情"/>
    </div>
</template>
<script>
import ss from '../../api/SystemService'
import createApply from "@/components/invoice/createPayment.vue";

export default {
    components: {createApply},
    data() {
        return {
            delData: {
                reviewComments: ''
            },
            tableData: [],
            //表格
            multipleSelection: [],
            showHistory: false,
            instid: "",
            fukuanId: null,
            showNewFukuan:false,
        }

    },

    methods: {

        //表格
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pass(aaa) {
            // 1通过 2驳回 驳回时填写驳回理由，通过时若未填写则默认填写通过
            if (aaa === 2 && !this.delData.reviewComments) {
                this.$msg.msge("请填写驳回理由");
                return
            }
            let query = {
                taskId: this.$route.query.taskid,
                aaa: aaa,
                reviewComments: this.delData.reviewComments ? this.delData.reviewComments : "通过",
                optFlag: aaa===1?"通过":"驳回",
                instId: this.$route.query.instid,
                ywid: this.$route.query.ywid,
                dataList: this.tableData,
            }
            ss.invoiceApplyList.approvalPayment(query).then(res => {
                this.$msg.alerts("提交成功！", () => {
                    //刷新右上角的代办个数
                    this.$store.dispatch("searchTasktotal")
                    //跳转回系统的代办列表
                    this.$router.push({
                        path: '/personal/dealCenter'
                    })
                })
            })
        },

        viewPress() {
            this.showHistory = true;
        },
        goBack() {
            this.$router.push({
                path: '/invoice/paymentList'
            })
        },
        getListByInstId(instId) {
            const query = {
                instId: instId,
            };
            ss.invoiceApplyList.selectPageByInstId(query).then(rd => {
                console.log("rd", rd);
                this.tableData = rd.msg;
                this.tableData.forEach(item => {
                    let createDate = new Date(item.cdate);
                    if (createDate > new Date('2026-01-01')) {
                        item.paymentSystem = '云报账';
                    } else {
                        item.paymentSystem = 'GEMS';
                    }
                })
            })
        },
        // 查看详情
        getFukuanData(o) {
            this.fukuanId = o;
            this.showNewFukuan = true;
        },

    },
    watch: {},
    created() {
        this.getListByInstId(this.$route.query.instid);
        this.instid = this.$route.query.instid;
    },
}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label {
    width: 100px;
}


/deep/ .h-formbLine .el-form-item__content {
    width: 150px;
}
</style>
